import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/public/${string | ':code'}/download`;

export const ROUTE: RouteDefinition = `${baseRoute}/public/:code/download`;

export const URL = (code: string): RouteDefinition => `${baseRoute}/public/${code}/download`;
